export const USER_WEEKLY_OVERVIEW_REQUEST = 'USER_WEEKLY_OVERVIEW_REQUEST'
export const USER_WEEKLY_OVERVIEW_SUCCESS = 'USER_WEEKLY_OVERVIEW_SUCCESS'
export const USER_WEEKLY_OVERVIEW_FAIL = 'USER_WEEKLY_OVERVIEW_FAIL'